// apps/app/src/App.tsx

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { CloudOff, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from './lib/auth';
import { AppRoutes } from './router';

export function App() {
  const { status, restore } = useAuth();
  const { t } = useTranslation('common');

  // The access token lives in memory, so every reload starts from the refresh
  // cookie. This is the normal path, not an error case.
  useEffect(() => {
    void restore();
  }, [restore]);

  if (status === 'loading') {
    return (
      <div className="grid min-h-dvh place-items-center bg-background" aria-busy="true">
        <Loader2 className="size-6 animate-spin text-muted-foreground" aria-label={t('app.loading')} />
      </div>
    );
  }

  if (status === 'unavailable') {
    return (
      <div className="grid min-h-dvh place-items-center bg-background p-6">
        <div className="max-w-sm text-center" role="alert">
          <span className="mx-auto mb-3 grid size-10 place-items-center rounded-full bg-muted text-muted-foreground">
            <CloudOff className="size-5" aria-hidden="true" />
          </span>
          <p className="text-sm font-medium">{t('app.unavailableTitle')}</p>
          <p className="mt-1 text-sm text-muted-foreground">
            {t('app.unavailableBody')}
          </p>
          <Button className="mt-4" onClick={() => void restore()}>
            {t('app.tryAgain')}
          </Button>
        </div>
      </div>
    );
  }

  return <AppRoutes />;
}
